import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  housingFundsDetailInputList2,
  housingFundsDetailInputList2_2011,
  housingFundsDetailInputList2_2012,
} from '../../../../common/data';
import HousingDetailItem from './HousingDetailItem';

import DetailButtonSection from '../../../../components/DetailButtonSection';
import DetailTitleSection from '../../../../components/DetailTitleSection';
import { getHousingFundsDataDetail, resetDetailData, saveHousingFunds } from '../housingFundsSlice';
import {
  getAlertMessageFunction,
  handleNumberChange2,
  magamCertifyCheck,
} from '../../../../common/Util';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import ItemTitleSection from '../../../../components/ItemTitleSection';
import { setIsDataModified } from '../../../common/commonSlice';

//장기 주택 저당 차입금
const Type2 = ({ onClose, isOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('deductions/housingFunds');
  const { t: tCommon } = useTranslation('common');
  const inputList2011 = housingFundsDetailInputList2_2011(t);
  const inputList2012 = housingFundsDetailInputList2_2012(t);

  const { isMagam, isCertify } = useSelector(state => state.common);
  const { detailData } = useSelector(state => state.housingFunds);
  const [dataList, setDataList] = useState({
    htm079: '',
    htm080: '',
    htm081: '',
    htm082: '',
    htm083: '',
    htm084: '',
    htm085: '',
    htm086: '',
    htm087: '',
    htm088: '',
    htm089: '',
    htm090: '',
    htm091: '',
    htm092: '',
  });

  useEffect(() => {
    if (isOpen) {
      dispatch(getHousingFundsDataDetail({ hInType: '2' }));
    }

    return () => {
      dispatch(resetDetailData());
    };
  }, [dispatch, isOpen]);

  useEffect(() => {
    if (detailData) {
      setDataList(detailData);
    }
  }, [detailData]);

  const handleChange = e => {
    let { name, value } = e.target;

    value = handleNumberChange2(value);
    dispatch(setIsDataModified(true));
    setDataList({ ...dataList, [name]: value });
  };

  const handleSave = async () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    const alertMessage = getAlertMessageFunction();
    let data = {
      hInType: '2',
      htm079: dataList?.htm079 || '0',
      htm080: dataList?.htm080 || '0',
      htm081: dataList?.htm081 || '0',
      htm082: dataList?.htm082 || '0',
      htm083: dataList?.htm083 || '0',
      htm084: dataList?.htm084 || '0',
      htm092: dataList?.htm092 || '0',
      htm093: dataList?.htm093 || '0',
      htm094: dataList?.htm094 || '0',
      htm095: dataList?.htm095 || '0',
      htm163: dataList?.htm163 || '0',
      htm164: dataList?.htm164 || '0',
      htm165: dataList?.htm165 || '0',
      htm166: dataList?.htm166 || '0',
      htm167: dataList?.htm167 || '0',
      htm168: dataList?.htm168 || '0',
      htm169: dataList?.htm169 || '0',
      htm170: dataList?.htm170 || '0',
    };

    try {
      const response = await dispatch(saveHousingFunds(data)).unwrap();
      console.log('response', response);
      if (response.resultCode === 'OK') {
        alertMessage(tCommon('alertMessage.saveSuccess'), 'success');
        onClose();
      } else {
        alertMessage(tCommon('alertMessage.saveFail'), 'error');
      }
    } catch (error) {
      console.log(error);
      alertMessage(tCommon('alertMessage.saveFail'), 'error');
    }
  };

  return (
    <SlideRightDialog onClose={onClose} isOpen={isOpen}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <DetailTitleSection title={t('detail.title2')} />
        {/* 2011년 이전 차입분 */}
        <ItemTitleSection title={t('detail.type2.typeTitle1')} buttonIcon={false} />
        <HousingDetailItem {...{ inputList: inputList2011, dataList, setDataList, handleChange }} />
        {/* 2012년 이후 차입분 */}
        <ItemTitleSection title={t('detail.type2.typeTitle2')} buttonIcon={false} />
        <HousingDetailItem {...{ inputList: inputList2012, dataList, setDataList, handleChange }} />
        <DetailButtonSection onSave={handleSave} onClose={onClose} />
      </div>
    </SlideRightDialog>
  );
};

export default Type2;
